import Chip from "@mui/material/Chip"

import { formatTalkTime } from "./formatTalkTime"

export default function TalkTimeCapsule({ talkTime, sx }) {
  return (
    <Chip
      size="small"
      label={`Talk Time ${formatTalkTime(talkTime)}`}
      sx={{
        ml: "auto",
        flexShrink: 0,
        borderRadius: "999px",
        fontWeight: 600,
        color: "colors.gray700",
        backgroundColor: "rgba(15, 118, 110, 0.12)",
        border: "1px solid",
        borderColor: "rgba(15, 118, 110, 0.28)",
        "& .MuiChip-label": {
          px: 1.25,
        },
        ...sx,
      }}
    />
  )
}
